var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurvesWheel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.3 136.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "curves-wheel_svg__st3",
    d: "M115.2 115.2c6.3-6.3 7.2-16 2.7-23.3l-8.6-13.8c-1.8-2.9-2.8-6.3-2.8-9.9s1-7 2.8-9.9l8.6-13.8c4.5-7.3 3.6-17-2.7-23.3-6.3-6.3-16-7.2-23.3-2.7L78.1 27c-2.9 1.8-6.3 2.8-9.9 2.8-3.6 0-7-1-9.9-2.8l-13.8-8.6c-7.3-4.5-17-3.6-23.3 2.7-6.3 6.3-7.2 16-2.7 23.3L27 58.2c1.8 2.9 2.8 6.3 2.8 9.9s-1 7-2.8 9.9l-8.6 13.8c-4.5 7.3-3.6 17 2.7 23.3 6.3 6.3 16 7.2 23.3 2.7l13.8-8.6c2.9-1.8 6.3-2.8 9.9-2.8s7 1 9.9 2.8l13.8 8.6c7.4 4.6 17.1 3.7 23.4-2.6z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeDasharray: "0.9992,0.9992"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "curves-wheel_svg__st0",
    d: "M68.2 134.6c8.9 0 16.4-6.2 18.4-14.5l3.7-15.8c.8-3.3 2.5-6.4 5-9 2.6-2.6 5.7-4.2 9-5l15.8-3.7c8.3-2 14.5-9.4 14.5-18.4s-6.2-16.4-14.5-18.4l-15.8-3.7c-3.3-.8-6.4-2.5-9-5-2.6-2.6-4.2-5.7-5-9l-3.7-15.8C84.6 8 77.2 1.8 68.2 1.8c-8.9 0-16.4 6.2-18.4 14.5L46.1 32c-.8 3.3-2.5 6.4-5 9-2.6 2.6-5.7 4.2-9 5l-15.8 3.7C8 51.7 1.8 59.1 1.8 68.1 1.8 77 8 84.5 16.3 86.5L32 90.3c3.3.8 6.4 2.5 9 5 2.6 2.6 4.2 5.7 5 9l3.7 15.8c2 8.3 9.5 14.5 18.5 14.5z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })));
}
export default SvgCurvesWheel;